/* eslint-disable */

import fullpage from 'fullpage.js/dist/fullpage'
import ScrollReveal from 'scrollreveal';

export default {
  init() {
    // JavaScript to be fired on all pages
    window.addEventListener("load",function(){
      
      var hamburger = document.querySelector(".cc-ham-nav");
      var menu = document.querySelector(".nav-primary");

      hamburger.addEventListener("click", function(){
        menu.classList.toggle("active");
        hamburger.classList.toggle("active");
      });

    });

    window.addEventListener("load",function(){
      
      var header = document.querySelector("header");
      var documentContainer = document.querySelector(".wrap");
      var wpAdminBar = document.querySelector("#wpadminbar");
      // var theBody = document.querySelector("body");
      var headerHeight;
      
      if(wpAdminBar) {
        headerHeight = header.clientHeight + wpAdminBar.clientHeight;
        appendScrolled(headerHeight);
      } else {
        headerHeight = header.clientHeight;
        appendScrolled(headerHeight);
      }

      function appendScrolled(actualHeaderHeight) {
        window.addEventListener("scroll",function(){
          if (this.window.scrollY > actualHeaderHeight) {
            header.classList.add("scrolled");
            documentContainer.classList.add("scrolled");
          } else {
            header.classList.remove("scrolled");
            documentContainer.classList.remove("scrolled");
          }
        });
      }

      // var myFullpage = new fullpage('.main', {
      //   menu: '#menu',
      //   anchors: ['screenOne', 'screenTwo', 'screenThree', 'caseOne', 'caseTwo', 'caseThree'],
      //   licenseKey: '87FA8A8B-E4634E5D-A0269B8D-98193ED5',
      //   autoScrolling: false,
      // });

      ScrollReveal().reveal(".reveal-item", {
        duration: 800,
        delay: 100,
        reset: false,
        viewFactor: 0.5,
        scale: 0.8,
      });

      jQuery(function() {
        jQuery(".sticky-container").stick_in_parent({
          offset_top: 100,
          recalc_every: 1,
        });
      });
    
    })

    jQuery(document).ready(function(){
      /* Replace all SVG images with inline SVG */
      jQuery('img.svg').each(function(){
        var $img = jQuery(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        jQuery.get(imgURL, function(data) {
            /* Get the SVG tag, ignore the rest */
            var $svg = jQuery(data).find('svg');

            /* Add replaced image's ID to the new SVG */
            if(typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }

            /* Add replaced image's classes to the new SVG */
            if(typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass+' replaced-svg');
            }

            /* Remove any invalid XML tags as per http://validator.w3.org */
            $svg = $svg.removeAttr('xmlns:a');

            /* Replace image with new SVG */
            $img.replaceWith($svg);

        }, 'xml');

      });
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js